import { Tooltip, Label, Checkbox, PopupDialogbox, AttachmentCommonUpload, ReactSelectBox, DropdownBox } from "../../../../../CommonComponents";
import "./LeadrOrderDetail.scss";
import { CONSTANTS } from "client/utils/constants";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import { useMemo } from "react";

const LeadrOrderDetail = (props: any) => {
  const {
    orderDetails,
    branchValue,
    Popupcontent,
    hideDialog,
    onUploadClick,
    onRemoveAttachment,
    setAttachmentError,
    attachmentError,
    setDocumentList,
    documentList,
    attachmentsList,
    CreateVehicleConsolidatedChecked,
    CreateManageEquipConsolidatedChecked,
    CreateNonStandardConsolidatedChecked,
    isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked,
    isVehicleChecked,
    isEquipmentChecked,
    isNonStandardChecked,
    iAttachmentEditable,
    isBulkOrder,
    getTotal,
    getOrderQty,
    onAssignedToToggleChange,
    assignTo,
    onAssignedToDropdownChange,
    isAssignedToChecked,
    assignedToForAllValue
  } = props;

  const assignToValue = useMemo(() => {
    return assignTo?.find(
      (x: any) => x.value === (assignedToForAllValue || "N/A")
    );
  }, [assignedToForAllValue, assignTo]);

  return (
    <>
      <div className="borderCard">
        <div>
          <Label className="orderTotalLable mb-1" data-attribute="LeadrOrderDetail_Default_Label">Cost Center</Label>
          <div>{branchValue?.text}</div>
        </div>
        <div>
          <Label className="mb-1" data-attribute="LeadrOrderDetail_Default_Label_2">Qty</Label>
          <Tooltip
            content={getOrderQty()}
           data-attribute="LeadrOrderDetail_Default_Tooltip">
            <div className="content">
              {getOrderQty()}
            </div>
          </Tooltip>
        </div>
        <div>
          {!isBulkOrder ?
            <>
              <Label data-attribute="LeadrOrderDetail_Default_Label_3">Pre-Authorized</Label>
              <Tooltip content={props.orderDetails?.isApprovalOverride} data-attribute="LeadrOrderDetail_Default_Tooltip_2">
                <div className="content">{props.orderDetails?.isApprovalOverride ? "Yes" : "No"}</div>
              </Tooltip>
            </>
            : null}
        </div>
        <div>
          <Label className="orderTotalLable" data-attribute="LeadrOrderDetail_Default_Label_4">Order Total</Label>
          <Tooltip
            content={
              "$" + getTotal()
            }
           data-attribute="LeadrOrderDetail_Default_Tooltip_3">
            <div className="content">
              <b>
                ${getTotal()}
              </b>
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="captitalLeaseBlock mb-3">
        <div className="clearfix">
        {/* ${props?.orderDetails?.fleetRequestTypeCount?.find((item: any) => item?.requestType === CONSTANTS.MANAGED_EQUIPMENT)?.count > 1} */}
          <div className= "float-left consolidatePO block">
            {props?.orderDetails?.fleetRequestTypeCount?.find((item: any) => item?.requestType === CONSTANTS.VEHICLE)?.count > 1 &&
              <div className="block mt-2 consolidatePO-block me-3">
                <Checkbox
                  onChange={(e: any) => {
                    CreateVehicleConsolidatedChecked(e);
                  }}
                  checked={isVehicleConsolidatedChecked==CONSTANTS.VEHICLE_REQUEST}
                  defaultChecked={false} className='mb-0'
                  disabled={isVehicleChecked || !iAttachmentEditable || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                 data-attribute="LeadrOrderDetail_Default_Checkbox" />
                <span className="block-Text consolidatePO-block-text">
                  Create Consolidated Vehicle Request PO
                </span>
              </div>
            }
            {/* <div className="block mt-2 consolidatePO-block requestfleet_check"> */}
              {props?.orderDetails?.fleetRequestTypeCount?.find((item: any) => item?.requestType === CONSTANTS.MANAGED_EQUIPMENT)?.count > 1 &&
                <div className="inside-checkbox mt-2">
                  <Checkbox
                    onChange ={(e: any) => {
                      CreateManageEquipConsolidatedChecked(e);
                    }}
                    disabled={isEquipmentChecked || !iAttachmentEditable || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                    checked={isManageEquipConsolidatedChecked==CONSTANTS.MANAGED_EQUIPMENT}
                    defaultChecked={false} className='mb-0' data-attribute="LeadrOrderDetail_Default_Checkbox_2" />
                  <span className="block-Text consolidatePO-block-text me-3">
                    Create Consolidated Managed Equipment PO Request
                  </span>
                </div>
              }
                <div className="inside-checkbox mt-2">
                {props?.orderDetails?.fleetRequestTypeCount?.find((item: any) => item?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT)?.count > 1 &&
                <>
                  <Checkbox
                    onChange={(e: any) => {
                      CreateNonStandardConsolidatedChecked(e);
                    }}
                    disabled={isNonStandardChecked || !iAttachmentEditable || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                    checked={isNonstandardConsolidatedChecked==CONSTANTS.NON_STANDARD_EQUIPMENT}
                    defaultChecked={false} data-attribute="LeadrOrderDetail_Default_Checkbox_3" />
                  <span className="block-Text consolidatePO-block-text">
                    Create Consolidated Non Standard Equipment PO Request
                  </span>
                </>}
                </div>
              {props?.orderDetails?.quantity > 1 &&
                <>
                  <div className="requestfleet_assignedto mt-2">
                    <div className="inside-checkbox">
                      <Checkbox
                        onChange={(e: any) => onAssignedToToggleChange(e)}
                        disabled={orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED}
                        checked={isAssignedToChecked}
                        defaultChecked={false}
                       data-attribute="LeadrOrderDetail_Default_Checkbox_4" />
                      <span className="block-Text consolidatePO-block-text">
                        Set Assigned To for all Items
                      </span>
                    </div>
                    <div className='assignedTo-fleet'>
                      <Label data-attribute="LeadrOrderDetail_Default_Label_5">Assigned To</Label>
                      <DropdownBox
                        name="assignedTo"
                        placeholder="Select"
                        options={assignTo}
                        onChange={onAssignedToDropdownChange}
                        selectedKey={assignToValue?.key}
                        disabled={orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED || !isAssignedToChecked}
                       data-attribute="LeadrOrderDetail_assignedTo_Dropdown" />
                    </div>
                  </div>
                </>
              }
            {/* </div> */}
          </div>
          {!isBulkOrder && <div className="float-right">
            <div className={`purchaseorder-attachement mt-2 ${props?.orderDetails?.orderRequestTypes?.find((item: any) => item === CONSTANTS.VEHICLE_REQUEST) && props?.orderDetails?.orderRequestTypes?.find((item: any) => item === CONSTANTS.MANAGED_EQUIPMENT) && props?.orderDetails?.orderRequestTypes?.find((item: any) => item === CONSTANTS.NON_STANDARD_EQUIPMENT) ? 'all-three-type' : ''}`}>
              <AttachmentCommonUpload
                link={true}
                list={documentList}
                setList={setDocumentList}
                multiple={true}
                uploadBtnClick={onUploadClick}
                error={attachmentError}
                maxSize={5}
                onRemove={(index:any) => onRemoveAttachment(index)}
                uploadedList={attachmentsList}
                tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                setError={setAttachmentError}
                iAttachmentEditable = {iAttachmentEditable}
                isDownloadable = {false}
                disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                isChangesBeingTracked={false}
               data-attribute="LeadrOrderDetail_Default_AttachmentCommonUpload" />
            </div>
          </div>}
        </div>
      </div>
      {Popupcontent.isDialogVisible ?
        <PopupDialogbox
          hideDialog={!Popupcontent.isDialogVisible}
          onDismiss={hideDialog}
          Popupcontent={Popupcontent}
          popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
          popupPrimarybtnOnclick={(
            item: any,
            _comments: string,
            actionby: string,
            value: any
          ) => {
            Popupcontent.popupPrimarybtnOnclick(
              item,
              _comments,
              actionby,
              value
            );
          }}
         data-attribute="LeadrOrderDetail_Default_PopupDilalogBox" />
        : ""}
    </>
  );
};

export default LeadrOrderDetail;
